module.exports = __webpack_public_path__ + "media/packs/images/partners/wog_bg-8c58584a1219777558aae394199d4fe5.jpg";